export function getLabel(tags) {
  if (tags.length === 0) {
    return 'No tags selected'
  }

  return `${tags.length} selected`
}
